import { render, staticRenderFns } from "./InfoPanelEnterprise.vue?vue&type=template&id=220ad38f"
import script from "./InfoPanelEnterprise.vue?vue&type=script&lang=ts"
export * from "./InfoPanelEnterprise.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports